import styled from 'styled-components';

const WeatherStyle = styled.div`
	--wBlockPad: var(--sp5x);
	--wBlockRad: var(--sp3x);
	--wTopBlockGap: var(--sp5x);

	--weatherInnerBlockGap: var(--sp3x);

	.weather-svg {
		width: var(--h5);
		height: var(--h5);
		display: flex;

		path {
			stroke: var(--primaryColor1);
			stroke-width: 1px;
		}
	}

	.weather-inner-block {
		display: flex;
		flex-direction: column;
		gap: var(--weatherInnerBlockGap);
		padding: var(--wBlockPad);
		border-radius: var(--wBlockRad);
		background-color: var(--bgPearl);
	}

	.w-top-block {
		display: flex;
		gap: var(--wTopBlockGap);
	}

	.w-first {
		display: flex;
		align-items: center;
		gap: var(--sp0-5x);
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeL}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXLMin}) {
		--wBlockPad: var(--sp4x);
		--wBlockRad: var(--sp2-5x);
		--wTopBlockGap: var(--sp4x);

		--weatherInnerBlockGap: var(--sp2-5x);
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeM}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeLMin}) {
		--wBlockPad: var(--sp3x);
		--wBlockRad: var(--sp2x);
		--wTopBlockGap: var(--sp3x);

		--weatherInnerBlockGap: var(--sp2x);
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeS}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeMMin}) {
		--wBlockPad: var(--sp3x);
		--wBlockRad: var(--sp2x);
		--wTopBlockGap: var(--sp3x);

		--weatherInnerBlockGap: var(--sp2x);
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXS}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeSMin}) {
		--wBlockPad: var(--sp3x);
		--wBlockRad: var(--sp2x);
		--wTopBlockGap: var(--sp3x);

		--weatherInnerBlockGap: var(--sp2x);
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.TabletSize}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXSMin}) {
		--wBlockPad: var(--sp3x);
		--wBlockRad: var(--sp2x);
		--wTopBlockGap: var(--sp3x);

		--weatherInnerBlockGap: var(--sp1-5x);
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.TabletSizeS}) and (max-width: ${({ theme }) => theme.mediaQuery.TabletSizeMin}) {
		--wBlockPad: var(--sp3x);
		--wBlockRad: var(--sp2x);
		--wTopBlockGap: var(--sp3x);

		--weatherInnerBlockGap: var(--sp1-5x);
	}

	@media only screen and (max-width: ${({ theme }) => theme.mediaQuery.TabletSizeSMin}) {
		--wBlockPad: var(--sp3x);
		--wBlockRad: var(--sp2x);
		--wTopBlockGap: var(--sp3x);

		--weatherInnerBlockGap: var(--sp1-5x);
	}
`;

export default WeatherStyle;
